
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/spectators/[season]",
      function () {
        return require("private-next-pages/bundesliga/spectators/[season]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/spectators/[season]"])
      });
    }
  